import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "highlight-header" }
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted, nextTick } from "vue";
import { getTeamEvaluationMemberResultsFragment } from "@/services/surveyResultsService";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import { colorCode } from "@/scripts/faculty/member-eval/color-assignment.js";
import { addTooltipContainer } from "@/scripts/tool-tip.js";
import { memberWorkGraph } from "@/scripts/student/midterm-viz-work.js";
import { memberTeamGraph } from "@/scripts/student/midterm-viz-team.js";
import {
  initializeAccordion,
  unbindAccordion,
} from "@/scripts/faculty/card-accordion.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamEvaluationMemberResults',
  props: {
    cohortId: {},
    cohortSurveyId: {},
    memberId: {},
    memberName: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  props,
});

const fragment = ref<string>();

onMounted(async () => {
  fragment.value = undefined;
  fragment.value = await getTeamEvaluationMemberResultsFragment(
    props.cohortId,
    props.cohortSurveyId,
    props.memberId
  );
  nextTick(() => {
    colorCode();
    addTooltipContainer();
    memberTeamGraph({
      SELECTOR: `[data-graph="member-teamwork"][data-member-id="${props.memberId}"]`,
    });
    memberWorkGraph({
      SELECTOR: `[data-graph="member-work"][data-member-id="${props.memberId}"]`,
    });
    unbindAccordion();
    initializeAccordion();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, [
      _createElementVNode("b", null, _toDisplayString(_ctx.memberName), 1)
    ]),
    (!fragment.value)
      ? (_openBlock(), _createBlock(LoadingIndicator, {
          key: 0,
          "loading-text": "Loading member results..."
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "results-section",
          innerHTML: fragment.value
        }, null, 8, _hoisted_2))
  ]))
}
}

})